import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

const canViewReport = () => {
  const user = store.state.main.user;
  if (!user) return false;
  return (
    user.isAdmin || (user.isEmployee && user.hasRole && user.hasRole("payroll"))
  );
};

const canViewOwnHistory = (route) => {
  const user = store.state.main.user;
  if (!user) return false;
  if (canViewReport()) return true;
  return Boolean(route?.params?.userID && user.id === route.params.userID);
};

export default {
  routes: [
    {
      name: "held-pay",
      path: "held-pay",
      meta: {
        auth: canViewReport,
        icon: "held_pay_to",
        title: i18n.global.t("Held Pay Report"),
        crumbs: ["accounting", "payroll"],
        color: "primary",
      },
      component: () => import("pages/accounting/payroll/HeldPayReport"),
    },
    {
      name: "held-pay-search",
      path: "held-pay/search/:query?",
      meta: {
        auth: canViewReport,
        icon: "held_pay_to",
        title: i18n.global.t("Held Pay Report"),
        crumbs: ["accounting", "payroll"],
        color: "primary",
        hideFromIndex: true,
      },
      component: () => import("pages/accounting/payroll/HeldPayReport"),
    },
  ],

  dialogs: [
    {
      name: "held-pay-history",
      path: "/users/:userID/held-pay/history",
      meta: {
        auth: canViewOwnHistory,
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/HeldPayHistory"),
    },
  ],
};
